import ButtonGallery from "@/components/Triggers/ButtonGallery";
import { chakra } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { DraftModelType } from "../types";

const allDraftModel = [
  DraftModelType.sd,
  DraftModelType.sd_20,
  DraftModelType.pixiv,
  DraftModelType.pixiv_hand,
  DraftModelType.indoor_design,
  DraftModelType["architecture"],
  DraftModelType["comic"],
  DraftModelType["arcane"],
  DraftModelType["food"],
  DraftModelType["pixel"],
  DraftModelType["retro"],
  DraftModelType["photo"],
  DraftModelType["dream_art"],
  DraftModelType["oil_paint"],
  DraftModelType["acg"],
  DraftModelType["soft"],
  DraftModelType["3D"],
  DraftModelType["sam"],
  DraftModelType["inkpunk"],
  // DraftModelType["petal"],
  DraftModelType["3D_icon"],
  DraftModelType["cartoon_wallpaper"],
  DraftModelType["character_simulation"],
  DraftModelType["antique_photo"],
  DraftModelType["crayon"],
  DraftModelType["colorful_art"],
  DraftModelType["2_5D_antique"],
];

const draftModelPreview = {
  [DraftModelType.sd]: "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/sd.png",
  [DraftModelType.sd_20]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/sd_20.png",
  [DraftModelType.pixiv]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/pixiv.png",
  [DraftModelType.pixiv_hand]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/pixiv_hand.png",
  [DraftModelType.indoor_design]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/indoor_design.png",
  [DraftModelType["architecture"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/architecture.png",
  [DraftModelType["comic"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/comic.png",
  [DraftModelType["arcane"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/arcane.png",
  [DraftModelType["food"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/food.png",
  [DraftModelType["pixel"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/pixel.png",
  [DraftModelType["retro"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/retro.png",
  [DraftModelType["photo"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/photo.png",
  [DraftModelType["dream_art"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/dream_art.png",
  [DraftModelType["oil_paint"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/oil_paint.png",
  [DraftModelType["acg"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/acg.png",
  [DraftModelType["soft"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/soft.jpeg",
  [DraftModelType["3D"]]: "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/3D.png",
  [DraftModelType["sam"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/sam.png",
  [DraftModelType["inkpunk"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/inkpunk.png",
  [DraftModelType["petal"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/petal.png",
  [DraftModelType["3D_icon"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/3D_icon.jpeg",
  [DraftModelType["cartoon_wallpaper"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/cartoon_wallpaper.jpeg",
  [DraftModelType["character_simulation"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/character_simulation.jpeg",
  [DraftModelType["antique_photo"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/antique_photo.png",
  [DraftModelType["crayon"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/crayon.jpeg",
  [DraftModelType["colorful_art"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/colorful_art.jpeg",
  [DraftModelType["2_5D_antique"]]:
    "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/models/draft/2_5D_antique.jpeg",
};

const IModelSelector: React.FC<{
  value: DraftModelType;
  setValue: (value: DraftModelType) => void;
  className?: string;
  title: string;
}> = ({ value, setValue, className, title }) => {
  return (
    <ButtonGallery
      className={className}
      textH={24}
      w="100%"
      mt="16px"
      panelTitle={title}
      collections={allDraftModel}
      images={draftModelPreview}
      storeValue={value}
      setStoreValue={setValue}
    />
  );
};

export const ModelSelector = chakra(IModelSelector);
